module.exports = __webpack_public_path__ + "img/400 (1)tel.9e39eecd.png";